module.exports = __webpack_public_path__ + "static/bitpay_dashboard_api_token-b98ddbba7745e4316052151a9159a75b.png";